<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!-- <v-card class="box" v-if="ay_std_div_list != null"> -->
    <v-card class="box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>WorkSheet Answer Key</strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
            :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="proceed" />
        </v-col>
      </v-row>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers3" :items="table_data" :search="search" class="mytable">
          <template v-slot:item.action="{ item }">
            <div>
              <v-btn depressed color="green" @click="evaluate(item)" :loading="fetch_loader">Proceed</v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      fetch_loader: null,
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
      overlay: false,
      snackbar: false,
      search: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      ay_std_div_list: null,
      sel_ay_data: null,
      table_data: [],
      headers3: [
        {
          text: "Sr. No.",
          value: "srno",
          align: "center",
        },
        {
          text: "Subject",
          value: "subject",
          align: "center",
        },
        {
          text: "Standard",
          value: "standard",
          align: "center",
        },
        {
          text: "Division",
          value: "division",
          align: "center",
        },
        {
          text: "Total WorkSheet Answer Key",
          value: "homework_count",
          align: "center",
        },
        {
          text: "Action",
          value: "action",
          align: "center",
        },
      ],
    };
  },
  mounted() {
    axios
      .post("/Homework/get_worksheet_data")
      .then((res) => {
        this.table_data = res.data.data;
        this.ay_std_div_list = res.data.ay_data;
        this.sel_ay_data = res.data.curr_ay;
      })
      .catch((error) => { })
      .finally(() => { });
  },
  methods: {
    proceed() {
      const data = {
        ay_id: this.sel_ay_data.ay_id,
      };
      this.overlay = true;
      axios
        .post("/Homework/fetch_ay_based_data_worksheet", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.data.length != 0) {
            this.table_data = res.data.data;
            this.sel_ay_data = res.data.curr_ay;
          }
          if (res.data.data.length == 0) {
            this.table_data = [];
            this.showSnackbar("#b71c1c", "No records found!"); // show snackbar
          }
        })
        .catch((error) => {
          // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          this.fetch_loader = false;
          this.overlay = false;
        })
        .finally(() => {
          this.fetch_loader = false;
          this.overlay = false;
        });
    },
    evaluate(item) {
      // alert("coi_id--"+item.coi_id)
      this.$store.commit("setcourse_off_id", item.course_off_id);
      this.$store.commit("setay_id", this.sel_ay_data.id);
      this.$store.commit("setdiv_off_id", item.division_offering_id);
      this.$store.commit("setcoi_id", item.coi_id);
      this.$router.push({ name: "add-new-worksheet" });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>

<style scoped></style>